import { environment } from '../enviroments';
import { HttpHandler } from './HttpHandler';
import { DeviceInfo } from '@capacitor/device';

export async function updateUsedDevices(deviceInfo: DeviceInfo) {
  const { data } = await HttpHandler({
    method: 'POST',
    url: `${environment.CLIENT_APP_URL}/devices`,
    data: deviceInfo,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return data.data;
}
